module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/018-lebanon-ddbee24f68bd6b2587c1a8635da8879e.svg";